<template>
<v-container fluid>
  <v-card>
    <v-col cols="12" sm="6" md="4">
      Trains Report {{$route.query.crew_id}}
    </v-col>
    <v-row class="mx-auto">
      <v-col v-for="(value, name) in summary">
        <v-chip :color="getSummaryColour(name)" dark>{{name}} : {{value}}</v-chip>
      </v-col>
    </v-row>
    <v-card-title>
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y full-width max-width="400px" min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="train_date" required :rules="dateRules" prepend-icon="event" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="train_date" no-title @input="initialize(false)"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <div class="text-center">
            <v-btn rounded color="primary" dark @click="initialize(true)">Calc. All</v-btn>
          </div>
        </v-col>
        <v-col>
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-col>
      </v-row>
    </v-card-title>
    </v-card>
    <div class="card-scene">
      <Container
        orientation="vertical"
        @drop="onColumnDrop($event)"
        drag-handle-selector=".column-drag-handle"
        @drag-start="dragStart"
        :drop-placeholder="upperDropPlaceholderOptions"
      >
        <Draggable v-for="column in scene.children" :key="column.id">
          <div :class="column.props.className">
            <div class="card-column-header">
              <span class="column-drag-handle">&#x2630;</span>
              {{ column.name }}
            </div>
            <Container
              orientation="horizontal"
              group-name="col"
              @drop="(e) => onCardDrop(column.id, e)"
              @drag-start="(e) => log('drag start', e)"
              @drag-end="(e) => log('drag end', e)"
              :get-child-payload="getCardPayload(column.id)"
              drag-class="card-ghost"
              drop-class="card-ghost-drop"
              :drop-placeholder="dropPlaceholderOptions"
            >
              <Draggable v-for="card in column.children" :key="card.id">
                <div :class="card.props.className" :style="card.props.style">
                  <div>{{ card.data.org }}</div>
                  <div>{{ getFormattedTime(card.data.dep) }}</div>
                  <div>{{ card.data.train_no }}</div>
                  <div>{{ getFormattedTime(card.data.arr) }}</div>
                  <div>{{ card.data.dest }}</div>
                </div>
              </Draggable>
            </Container>
          </div>
        </Draggable>
      </Container>
    </div>

</v-container>
</template>

<script>
import { Container, Draggable } from 'vue-smooth-dnd'
import { applyDrag, generateItems } from '../js/utils'
import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'
import {
  mapState,
  mapGetter,
  mapActions
} from 'vuex'
const lorem = `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.`
const columnNames = ['Lorem', 'Ipsum', 'Consectetur', 'Eiusmod']
const cardColors = [
  'azure',
  'beige',
  'bisque',
  'blanchedalmond',
  'burlywood',
  'cornsilk',
  'gainsboro',
  'ghostwhite',
  'ivory',
  'khaki'
]
const pickColor = () => {
  const rand = Math.floor(Math.random() * 10)
  return cardColors[rand]
}
export default {
  name: 'rake_report',
  components: {Container, Draggable},
  data() {
    return {
      scene: {
        type: 'container',
        props: {
          orientation: 'horizontal'
        },
        children: []
      },
      upperDropPlaceholderOptions: {
        className: 'cards-drop-preview',
        animationDuration: '150',
        showOnTop: true
      },
      dropPlaceholderOptions: {
        className: 'drop-preview',
        animationDuration: '150',
        showOnTop: true
      },
      search: '',
      valid: false,
      dateRules: [v => !!v || 'Date is required'],
      errors: [],
      train: {},
      train_loading: false,
      trains: [],
      train_date: this.curTrainDate || moment().format('YYYY-MM-DD'),
      menu1: false,
      menu2: false,
      isLoading: false,
      summary: {}
    }
  },
  computed: {
    ...mapState(['curDeviceId', 'curDeviceName', 'curTrainNo', 'curTrainDate', 'curOrg', 'curArr', 'curDest', 'curDep','curCrewId',
     'actDep', 'actArr','curStartDate','curEndDate',]),
  },


  created() {

    console.log(this.train_date)
    console.log(this.curTrainDate)
    this.train_date= this.curTrainDate || moment().format('YYYY-MM-DD'),
    this.initialize(false)
  },

  methods: {
    ...mapActions(['updateCurDeviceId', 'updateCurDeviceName', 'updateCurTrainNo', 'updateCurTrainDate', 'updateCurOrg', 'updateCurCrewId',
     'updateCurArr', 'updateCurDest', 'updateCurDep', 'updateActDep', 'updateActArr','updateCurStartDate','updateCurEndDate']),
    initialize(calcall) {
      this.menu1 = false
      console.log(this.train_date)
      console.log(this.curTrainDate)
      this.updateCurTrainDate(moment(this.train_date).format("YYYY-MM-DD"))
        console.log(this.curTrainDate)
      //      console.log(this.curDeviceId)
      this.isLoading = true
      this.trains = []
      var p = {
        train_date: this.curTrainDate,
        calcall: calcall,
        start_date: this.$route.query.start_date,
        end_date: this.$route.query.end_date,
        crew_id: this.$route.query.crew_id,
        train_no: this.curTrainNo,
        device_id: this.curDeviceId,
        org: this.curOrg,
        dest: this.curDest,
      }
      console.log(p)
      var endPoint = 'reportforperiod'
      if (calcall) {
        endPoint = 'recalctrainreport'
      }
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`${process.env.VUE_APP_API_URL}/train/tr/${endPoint}`, {
          params: p
        })
        .then(response => {
          console.log(response);
          this.trains = response.data
          var rakewise_trains =_.sortBy( _.groupBy(response.data, 'device_name'), 'dep')
            console.log(rakewise_trains)
            var rakes =[]
          _.forEach(rakewise_trains, function(value, key) {
               console.log(key);
               var rake = {
                 id: `column${key}`,
                 type: 'container',
                 name: value[0]['device_name'],
                 props: {
                   orientation: 'vertical',
                   className: 'card-container'
                 },
                 children: []
               }
               _.forEach(value, function(v, k) {
                    console.log(k,v);
                    var train = {
                      type: 'draggable',
                      id: `${v['train_no']}`,
                      props: {
                        className: 'card',
                        style: {backgroundColor: pickColor(),fontSize: '12px'}
                      },
                      data: {
                        train_no: v['train_no'],
                        dep: v['dep'],
                        org: v['org'],
                        dest: v['dest'],
                        arr: v['arr']
                      }
                    }
                    rake.children.push(train)
               });
               rakes.push(rake)
          });
          this.scene.children = rakes
          this.summary = this.getSummary(response.data)
          this.isLoading = false
          this.updateCurCrewId(null)
          this.updateCurTrainNo(null)
          this.updateCurOrg(null)
          this.updateCurDest(null)
        })
        .catch(e => {
          console.log(e)
          this.isLoading = false
        })
    },

    onColumnDrop (dropResult) {
      const scene = Object.assign({}, this.scene)
      scene.children = applyDrag(scene.children, dropResult)
      this.scene = scene
    },
    onCardDrop (columnId, dropResult) {
      if (dropResult.removedIndex !== null || dropResult.addedIndex !== null) {
        const scene = Object.assign({}, this.scene)
        const column = scene.children.filter(p => p.id === columnId)[0]
        const columnIndex = scene.children.indexOf(column)
        const newColumn = Object.assign({}, column)
        newColumn.children = applyDrag(newColumn.children, dropResult)
        scene.children.splice(columnIndex, 1, newColumn)
        this.scene = scene
      }
    },
    getCardPayload (columnId) {
      return index => {
        return this.scene.children.filter(p => p.id === columnId)[0].children[index]
      }
    },
    dragStart () {
      console.log('drag started')
    },
    log (...params) {
      console.log(...params)
    },

    //update traccar_db.device_train_map set dep = addtime(train_date, time(dep)), arr = addtime(train_date, time(arr));
    //update traccar_db.device_train_map set arr = adddate(arr, 1) where arr < dep;
  getFormattedDate(t) {
      if (t) {
        var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
        var testDateUtc = moment.utc(lt);
        var localDate = moment(testDateUtc).local();
        return localDate.format("DD/MM/YYYY")
      } else {
        return '--'
      }
    },
    getFormattedTime(t) {
      if (t !== '--') {
       //  var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
       //  var testDateUtc = moment.utc(lt);
       // var localDate = moment(testDateUtc).local();
       //  return moment(localDate).format("HH:mm:ss")
       return moment.utc(t).format("HH:mm")
      }
    },
    getFormattedTimeSec(t) {
      if (t < 0) {
        return '-' + moment.utc(Math.abs(t) * 1000).format('HH:mm:ss')
      } else {
        return moment.utc(Math.abs(t) * 1000).format('HH:mm:ss')
      }
    },

    getColour(train) {
      if (train.act_arr) {
        let x = train.late_arr / 60
        switch (true) {
          case (x < 1):
            return 'green'
            break;
          case (x < 5):
            return '#6B8E23'
            break;
          case (x < 11):
            return 'blue'
            break;
          case (x < 21):
            return 'orange'
            break;
          case (x < 31):
            return '#FF1493'
            break;
          case (x < 1000):
            return 'red'
            break;
          default:
            return '#F5DEB3'
            break;
        }
      }
    },
    getSummaryColour(s) {
      return s == "more than 30" ? 'red' :
        s == "21 to 30" ? '#FF1493' :
        s == "11 to 20" ? 'orange' :
        s == "5 to 10" ? 'blue' :
        s == "less than 5" ? '#6B8E23' :
        s == "Right Time" ? 'green' :
        s == "total late" ? '#A52A2A' :
        s == "total train" ? '#D2691E' :
        s == "Puctuality" ? '#8A2BE2' :
        '#F5DEB3'
    },
    getSummary(trains) {
      let summary = {
        "Right Time": 0,
        "less than 5": 0,
        "5 to 10": 0,
        "11 to 20": 0,
        "21 to 30": 0,
        "more than 30": 0,
        "total late": 0,
        "total train": 0,
        "Puctuality": 0
      }
      _.forEach(trains, (train) => {
        if (train.act_arr) {
          let x = train.late_arr / 60
          switch (true) {
            case (x < 1):
              summary["Right Time"]++;
              summary["total train"]++;
              break;
            case (x < 5):
              summary["less than 5"]++;
              summary["Right Time"]++;
              summary["total train"]++;
              break;
            case (x < 11):
              summary["5 to 10"]++;
              summary["total late"]++;
              summary["total train"]++;
              break;
            case (x < 21):
              summary["11 to 20"]++;
              summary["total late"]++;
              summary["total train"]++;
              break;
            case (x < 31):
              summary["21 to 30"]++;
              summary["total late"]++;
              summary["total train"]++;
              break;
            case (x < 1000):
              summary["more than 30"]++;
              summary["total late"]++;
              summary["total train"]++;
              break;
            default:
              break;
          }
        }
      })
      summary["Puctuality"] = Math.round((summary["Right Time"] / summary["total train"]) * 100, 2)
      return summary
    }
  }
}
</script>
<style>
.draggable-item {
    height: 50px;
    line-height: 50px;
    text-align: center;
    display: block;
    background-color: #fff;
    outline: 0;
    border: 1px solid rgba(0, 0, 0, .125);
    margin-bottom: 2px;
    margin-top: 2px;
    cursor: default;
    user-select: none;
}

.draggable-item-horizontal {
    height: 300px;
    padding: 10px;
    line-height: 100px;
    text-align: center;
    /* width : 200px; */
    display: block;
    background-color: #fff;
    outline: 0;
    border: 1px solid rgba(0, 0, 0, .125);
    margin-right: 4px;
    cursor: default;
}

.dragging {
    background-color: yellow;
}

.card-scene {
    max-width: 95vw;
    max-height: 75vh;
    padding: 50px;
    overflow: auto;
    /* background-color: #fff; */
}

.card-container {
    padding: 10px;
    margin: 5px;
    margin-right: 45px;
    background-color: #f3f3f3;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12), 0 1px 1px rgba(0, 0, 0, 0.24);
    overflow-x: auto;
}

.card {
    margin: 5px;
    /* border: 1px solid #ccc; */
    background-color: white;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12), 0 1px 1px rgba(0, 0, 0, 0.24);
    padding: 10px;
}

.card-column-header {
    font-size: 12px;
}

.column-drag-handle {
    cursor: move;
    padding: 5px;
}

.card-ghost {
    transition: transform 0.18s ease;
    transform: rotateZ(5deg)
}

.card-ghost-drop {
    transition: transform 0.18s ease-in-out;
    transform: rotateZ(0deg)
}

.opacity-ghost {
    transition: all .18s ease;
    opacity: 0.8;
    /* transform: rotateZ(5deg); */
    background-color: cornflowerblue;
    box-shadow: 3px 3px 10px 3px rgba(0, 0, 0, 0.3);
}

.opacity-ghost-drop {
    opacity: 1;
    /* transform: rotateZ(0deg); */
    background-color: white;
    box-shadow: 3px 3px 10px 3px rgba(0, 0, 0, 0.0);
}


.form-demo {
    width: 650px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 50px;
    display: flex
}

.form {
    flex: 3;
    /* width: 500px; */
    /* background-color: #f3f3f3; */
    border: 1px solid rgba(0, 0, 0, .125);
    border-radius: 6px;
    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.08), 0px 3px 3px rgba(0, 0, 0, 0.08);
}

.form-fields-panel {
    flex: 1;
    margin-right: 50px;
}


.form-ghost {
    transition: 0.18s ease;
    box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.08);
}

.form-ghost-drop {
    box-shadow: 0 0 2px 5px rgba(0, 0, 0, 0.0);
}

.drop-preview {
  background-color: rgba(150, 150, 200, 0.1);
  border: 1px dashed #abc;
  margin: 5px;
}

.cards-drop-preview {
  background-color: rgba(150, 150, 200, 0.1);
  border: 1px dashed #abc;
  margin: 5px 45px 5px 5px;
}
</style>
